import { render, staticRenderFns } from "./unconnect-complete.page.vue?vue&type=template&id=1d6a4e3f&scoped=true&"
import script from "./unconnect-complete.page.vue?vue&type=script&lang=js&"
export * from "./unconnect-complete.page.vue?vue&type=script&lang=js&"
import style0 from "./unconnect-complete.page.vue?vue&type=style&index=0&id=1d6a4e3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6a4e3f",
  null
  
)

export default component.exports